import React from 'react'
import Frame1 from '../../../../../../../../public/assets/img/WomansCategory/s1.png'
import Frame2 from '../../../../../../../../public/assets/img/WomansCategory/s2.png'
import Frame3 from '../../../../../../../../public/assets/img/WomansCategory/s3.png'
import Frame4 from '../../../../../../../../public/assets/img/WomansCategory/s4.png'
import FindYourStyleBanner from '../../../../../../../../public/assets/img/bannerBg.svg'
import MobileFindYourStyleBanner from '../../../../../../../../public/assets/img/mobileTradendingBg.png'
import { WOMEN_SECTION_TEXT } from 'src/Helpers/Json/WomanCategoryList'
import FindYourStyleMobile from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/FindYourStyle/FindYourStyleMainSection/FindYourStyleMobile'
import FindYourStyleWeb from 'src/components/Category/MainCategory/WomenCategory/WomanPageModal/FindYourStyle/FindYourStyleMainSection/FindYourStyleWeb'
import { useRouter } from 'next/router'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useAppDispatch } from 'src/store/store'
export default function FindYourStyleMainSection({ PageDataFun, setsubPage, selectedStyle, setMenStyleData }) {
  const router = useRouter()
  const dispatch = useAppDispatch()

  const Cards = [
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
        },
        {
          img: Frame2,
          type: 'small',
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame2,
          type: 'small',
        },
        {
          img: Frame1,
          type: 'small',
        },
      ],
    },
    {
      img: Frame4,
      type: 'large',
      parent_fill: false,
      child: [],
    },
    {
      img: Frame3,
      type: 'large',
      parent_fill: false,
      child: [],
    },
    {
      img: null,
      type: null,
      parent_fill: true,
      child: [
        {
          img: Frame1,
          type: 'small',
        },
        {
          img: Frame2,
          type: 'small',
        },
      ],
    },
  ]
  return (
    <div className="findYourStyles-section">
      <div className="findYourStyles-back-alignment">
        <div
          className="back_details-alignment"
          onClick={() => {
            router.push('/fashion/women/', undefined, { scroll: false })
            dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
          }}
        >
          <div>
            <img src="/assets/icon/left-icon.svg" alt="back-page" />
          </div>
          <p>Woma...</p>
        </div>
        <div className="mobile-heading-alignment">
          <h4>Find Your Style</h4>
        </div>
      </div>
      <div className="findYourStyles-banner">
        <div className="findYourStyles-banner-img-alignment">
          <img src={FindYourStyleBanner.src} alt="FindYourStyleBanner" />
          <img src={MobileFindYourStyleBanner.src} alt="MobileFindYourStyleBanner" className="mobile-view-banner" />
        </div>
        <div className="container">
          <div className="findYourStyles-banner-section">
            <div
              className="left-arrow-alignment"
              onClick={() => {
                router.push('/fashion/women/', undefined, { scroll: false })
                dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
              }}
            >
              <img src="/assets/icon/leftArrow.svg" alt="left-arrow" />
            </div>
            <div className="findYourStyles-heading-alignment">
              <h4>Find Your Style</h4>
              <p>{WOMEN_SECTION_TEXT.find_your_style.text}</p>
            </div>
          </div>
        </div>
      </div>
      <FindYourStyleMobile setsubPage={setsubPage} Cards={Cards} selectedStyle={selectedStyle} />
      <FindYourStyleWeb
        setsubPage={setsubPage}
        Cards={Cards}
        setMenStyleData={setMenStyleData}
        PageDataFun={PageDataFun}
      />
    </div>
  )
}
